import React from 'react';

class CheckboxCellComponent extends React.Component {

  render() {
    const { value } = this.props;
    return (
      <input type="checkbox" checked={!!value} disabled readOnly />
    )
  }

}

export default CheckboxCellComponent;



// WEBPACK FOOTER //
// ./src/views/applications/checkbox-cell.js